import React from 'react';

import request from '../../lib/request';
import { reqAPI } from '../../server/reqAPI';
import utils from '../../lib/utils';
import DeviceBindDialog from './DeviceBindDialog';
import { Utils } from '../../utils/Utils';

import './index.scss';
import { param } from 'jquery';

export default class extends React.Component {
    state = {
        deviceList: null
    }

    componentDidMount() {
        utils.getAppParams(param => {
            console.log(param)
            if (param) {
                this.setState({
                    param
                }, this.getDevice);
            }
        }, '', '', true);
    }

    getDevice = callback => {
        const { param } = this.state;

        request(reqAPI.get_device, param, { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res && res.code && res.code === 200 && res.data) {
                    this.setState({
                        deviceList: res.data.deviceVOS
                    }, () => {
                        callback && callback();
                    });
                }
            });
    }

    handleClickUnbind = uuid => {
        this.setState({
            currentUuid: uuid,
            showSureModel: true
        });
    }

    handleSureUnbind = () => {
        const { currentUuid, param } = this.state;
        const { handleBindSuccess } = this.props;

        request(reqAPI.unbind_device, Object.assign({}, param, { unBindUuid: currentUuid }), { method: 'GET' })
            .then(res => res.json())
            .then(res => {
                if (res && res.code && res.code === 200) {
                    // 如果退出设备是当前设备，则直接退出，否则刷新数据
                    if (param && param.uuid && param.uuid === currentUuid) {
                        this.settingLogout();
                    } else {
                        this.setState({
                            showSureModel: false,
                            currentUuid: '',
                        }, () => {
                            this.getDevice(() => {
                                handleBindSuccess && handleBindSuccess();
                            });
                        });
                    }
                } else {
                    utils.showTips(res.msg || '解绑失败');
                }
            });
    }

    handleClickBack = () => {
        const { handleBack } = this.props;

        handleBack && handleBack();
    }

    // 退出登录
    settingLogout = () => {
        Utils.delCookie("putaoid", window.location.hostname, "/");
        Utils.delCookie("token", window.location.hostname, "/");

        window.location = `#/login`;
    }

    render() {
        const { deviceList, showSureModel } = this.state;

        return (
            <div className='device-management'>
                <div className='device-management-back' onClick={this.handleClickBack} />
                <div className='device-management-title'>绑定管理</div>
                <div className='device-management-wrapper'>
                    <div className='device-management-tips'>每个步步ABC账号最多可登录并绑定2台设备。若超过2台，请先将如下设备解除绑定：</div>
                    {deviceList && Array.isArray(deviceList) && deviceList.map((item, index) => (
                        <div
                            key={index}
                            className='device-item'
                        >
                            <div className='device-item-device'>设备名称：{item.deviceName}</div>
                            <div className='device-item-other-info'>
                                <div className='other-info-box'>
                                    <div>首次登录</div>
                                    <div>{item.firstLoginTime}</div>
                                </div>
                                <div className='other-info-box'>
                                    <div>最后登录</div>
                                    <div>{item.lastLoginTime}</div>
                                </div>
                                <div className='unbind-button' onClick={() => { this.handleClickUnbind(item.uuid || '') }}>解除绑定</div>
                            </div>
                        </div>
                    ))}
                </div>
                {showSureModel &&
                    <DeviceBindDialog
                        type='bind'
                        contentText='您确认解除这台设备的绑定吗？'
                        buttonLeftText='取消'
                        buttonRightText='确定'
                        buttonLeftClick={() => { this.setState({ showSureModel: false }) }}
                        buttonRightClick={() => { this.handleSureUnbind() }}
                    />}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/Device/DeviceManagement.js